export default "__VITE_ASSET__B3Yfs4Nx__"